// extracted by mini-css-extract-plugin
export default {"actions":"actions___owGy_","pageInfo":"pageInfo___uNBki","zoomRatio":"zoomRatio___Ba5Ok","zoomContainer":"zoomContainer___gPRGe","buttons":"buttons___CyqX8"};